import React from "react"
import types from "prop-types"
import { Checkbox } from "shared/checkboxes"

const UserActiveStatusFilter = ({ onChange, value }) => (
  <div className="flex flex-col gap-2">
    <div className="flex flex-row items-center gap-2">
      <Checkbox
        className="cursor-pointer"
        uuid="user-active-status-filter-active"
        value={value.true}
        onChange={onChange(true)}
      />
      <label htmlFor="user-active-status-filter-active" className="cursor-pointer">
        Active
      </label>
    </div>
    <div className="flex flex-row items-center gap-2">
      <Checkbox
        className="cursor-pointer"
        uuid="user-active-status-filter-inactive"
        value={value.false}
        onChange={onChange(false)}
      />
      <label htmlFor="user-active-status-filter-inactive" className="cursor-pointer">
        Inactive
      </label>
    </div>
  </div>
)

UserActiveStatusFilter.propTypes = {
  onChange: types.func.isRequired,
  value: types.shape({
    [true]: types.bool,
    [false]: types.bool,
  }).isRequired,
}

export default UserActiveStatusFilter
